import { SITE_ACCESS_ROLES } from './siteAccessRoles';

/** Имена ролей Discord для управления сайтом (GTA5RP). */
export const ROLES = {
  ADMIN: 'admin',
  CHIEF_MANAGER: 'Chief Manager',
  DEPUTY_CHIEF_MANAGER: 'Deputy Chief Manager',
  SENIOR_MANAGER: 'Senior Manager',
};

export const ADMIN_ONLY = [ROLES.ADMIN];
export const CHIEF_AND_ABOVE = [ROLES.ADMIN, ROLES.CHIEF_MANAGER];
export const DEPUTY_AND_ABOVE = [ROLES.ADMIN, ROLES.CHIEF_MANAGER, ROLES.DEPUTY_CHIEF_MANAGER];
export const SENIOR_AND_ABOVE = [...SITE_ACCESS_ROLES];

export const MANAGER_MODERATOR_ROLE = 'Manager';

export function isManagerModeratorRole(roleName) {
  return String(roleName || '').trim().toLowerCase() === 'manager';
}

export function isJuniorOnlyRoleName(roleName) {
  const lower = String(roleName || '').trim().toLowerCase();
  return (lower === 'junior' || lower.includes('junior')) && !isManagerModeratorRole(roleName);
}

export function hasAnyRole(userRoles, allowedRoles) {
  if (!Array.isArray(userRoles)) return false;
  return allowedRoles.some((role) => userRoles.includes(role));
}

export function formatRolesList(roles) {
  return roles.join(', ');
}
